<template>
    <div class="notice-detail">
        <div class="ql-editor">
            <div v-html="noticeInfo.subject"></div>
            <div v-html="noticeInfo.body"></div>
        </div>
        <div class="backButton">
            <Button @click="backPage()">返回</Button>
            <Button icon="ios-download-outline" type="primary" v-if="hasFile" @click="downloadFile(noticeFile)" style="margin-left: 20px">附件下载</Button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    data() {
        return {
            noticeInfo: {},
            noticeFile: {},
            hasFile: false
        }
    },
    created() {
        axios.post('/announcement/selAnnouncementInfo', { id: this.$route.query['id'] }).then(res => {  // 查公告
            if (res != null && res.length > 0) {
                this.noticeInfo = JSON.parse(JSON.stringify(res[0]))
            }
        })
        axios.post('/announcement/selAttachmentInfo', { id: this.$route.query['id'] }).then(res => {  // 查附件
            if (res != null && res.length > 0) {
                this.noticeFile = JSON.parse(JSON.stringify(res[0]))
            }
            if (this.noticeFile.resource_id && this.noticeFile.resource_id.length > 0) {
                this.hasFile = true
            }
        })
    },
    methods: {
        backPage(){
            this.$router.back()
        },
         downloadFile(attach){
            axios({
                url: '/resource/download',
                method: 'post',
                data: { 'resourceId': attach.resource_id },
                responseType: 'blob'
            }).then(res => {
                var A = this.$store.getters.pageData.axiosHeader['content-disposition'].split('fileName=')[1]
                var FileSaver = require('file-saver')
                FileSaver.saveAs(new Blob([res]), decodeURIComponent(A))
            })
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail{
    min-height: 500px;
    position: relative;
    .backButton{
        position: absolute;
        bottom: -60px;
        right: -16px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/process/SystemSettings/AnnouncementDetails.vue